import cloudServiceModule from '../cloudService.module';

class PermissionApiService {
    constructor(__env, $http, $q) {
        this.__env = __env;
        this.$http = $http;
        this.$q = $q;
    }

    getPermissions(moduleName) {
        var deferred = this.$q.defer();
        this.$http
            .get(`${this.__env.cloudApiUrl}/permission/v1/permissions`, {
                params: {
                    moduleName: moduleName
                }
            })
            .then(
                response => deferred.resolve(response.data),
                response => deferred.reject(response.data)
            );
        return deferred.promise;
    }

    getPermissionsOfUser(userGuid, moduleName) {
        let deferred = this.$q.defer();
        this.$http
            .get(
                `${
                    this.__env.cloudApiUrl
                }/permission/v1/users/${userGuid}/permissions`,
                {
                    params: {
                        moduleName
                    }
                }
            )
            .then(
                response => deferred.resolve(response.data),
                response => {
                    if (response.status == 404) {
                        deferred.resolve({
                            notFound: true
                        });
                        return;
                    }
                    deferred.reject(response.data);
                }
            );
        return deferred.promise;
    }

    getUserPermissionsOfAccount(accountGuid, moduleName) {
        var deferred = this.$q.defer();
        this.$http
            .get(
                `${
                    this.__env.cloudApiUrl
                }/permission/v1/accounts/${accountGuid}/userpermissions`,
                {
                    params: {
                        moduleName: moduleName
                    }
                }
            )
            .then(
                response => deferred.resolve(response.data),
                response => {
                    var hasNoData = response.status == 404;
                    if (hasNoData) {
                        deferred.resolve({
                            hasNoData: hasNoData
                        });
                        return;
                    }
                    deferred.reject(response.data);
                }
            );
        return deferred.promise;
    }

    createUserPermissions(cloudToken, accountGuid, userPermissions) {
        var deferred = this.$q.defer();
        this.$http
            .post(
                `${
                    this.__env.cloudApiUrl
                }/permission/v1/accounts/${accountGuid}/userpermissions`,
                userPermissions,
                {
                    headers: {
                        token: cloudToken
                    }
                }
            )
            .then(
                response => deferred.resolve(response.data),
                response => deferred.reject(response.data)
            );
        return deferred.promise;
    }
}

export default cloudServiceModule.service(
    'permissionApiService',
    PermissionApiService
);



// WEBPACK FOOTER //
// ./modules/cloudService/permissionApi/permissionApi.service.js